import { render } from "./App.vue?vue&type=template&id=e5158d2a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e5158d2a&lang=less"

import exportComponent from "E:\\project\\eyes-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__